import type { EventStatus } from '../util/events.constants';

interface IActivityState {
    isLoading: boolean;
    cursor: null | string;
    hasMore: boolean;
    feed: IActivity[];
}

export interface IActivity {
    id: string;
    activity: string;
    metadata: Record<string, unknown>;
    status: EventStatus;
    time: string;
}

interface IFeedLoadCompleteAction {
    type: 'complete';
    payload: {
        feed: IActivity[];
        hasMore: boolean;
        cursor: string;
    };
}

type FeedAction = IFeedLoadCompleteAction | { type: 'reset' | 'loaded' | 'loading' };

export function activityFeedReducer(state: IActivityState, action: FeedAction) {
    switch (action.type) {
        case 'reset':
            return INITIAL_STATE;
        case 'complete':
            return {
                ...state,
                feed: [...state.feed, ...(action.payload?.feed ?? [])],
                hasMore: action.payload?.hasMore ?? false,
                cursor: action.payload?.cursor ?? null,
            };
        case 'loading':
            return {
                ...state,
                isLoading: true,
            };
        case 'loaded':
            return {
                ...state,
                isLoading: false,
            };
    }

    throw new Error('Unhandled action');
}

export const INITIAL_STATE: IActivityState = {
    isLoading: false,
    cursor: null,
    hasMore: true,
    feed: [] as IActivity[],
};
